import { Component, inject, OnInit } from "@angular/core";
import { MaintenanceService } from "@kpx/quickscan";
import { SessionService } from "../../../services/session.service";

@Component({
  selector: "app-maintenance",
  templateUrl: "./maintenance.component.html",
  styleUrls: ["./maintenance.component.less"],
})
export class MaintenanceComponent implements OnInit {
  public maintenance: MaintenanceService;
  public session: SessionService;
  public messages: string[];

  public constructor() {
    this.maintenance = inject(MaintenanceService);
    this.session = inject(SessionService);
    this.messages = [];
  }

  public ngOnInit(): void {
    this.messages = this.maintenance.getMaintenanceMessages();
  }
}
